import { useRef, useEffect } from "react";
import "./CustomTextarea.scss";

const CustomTextarea = ({ id, name, label, value, onChange, error }) => {
  const textareaRef = useRef(null); // без типизации

  const autoResize = () => {
    const el = textareaRef.current;
    if (el) {
      el.style.height = "auto";
      el.style.height = el.scrollHeight + "px";
    }
  };

  useEffect(() => {
    autoResize(); // при монтировании
  }, []);

  return (
    <div className="custom-textarea">
      <textarea
        ref={textareaRef}
        className="custom-textarea__field"
        id={id}
        name={name}
        required
        placeholder=" "
        onInput={autoResize}
        value={value}
        onChange={onChange}
      />
      <label className="custom-textarea__label" htmlFor={id}>
        {label}
      </label>
      <div className="custom-textarea__underline"></div>
       {error && <span className="error">{error}</span>}
    </div>
  );
};

export default CustomTextarea;